import { createSelector } from '~/techstyle-shared/redux-core';

import { getGender } from '../utils/useGender';

import { getProfileSizeFilters } from './getProfileSizeFilters';

export const getProfileSizeFiltersFromState = createSelector(
  [(state) => state.customer, getGender, (state) => state.intl.locale],
  (customer, { gender }, locale) => {
    return getProfileSizeFilters(customer, gender, locale);
  }
);
